<template>
  <div class="page page-minimal pt-3">
    <b-navbar class="minimal-nav d-flex justify-content-center align-items-center mb-3" v-if="company && !isNativeApp">
      <b-navbar-brand class="m-0" :to="companyURL">
        <img v-if="companyLogo" :src="companyLogo"/>
        <h2 v-else>{{ companyName }}</h2>
      </b-navbar-brand>
    </b-navbar>

    <b-container v-if="statuses.length">
      <status-bar v-for="(status, i) in statuses" :key="i" class="m-2" :status="status"/>
    </b-container>

    <b-container fluid>
      <slot :companyID="companyID"/>
    </b-container>
  </div>
</template>

<script>
import _get from 'lodash/get';
import { getStatusesForRoute } from '@/lib/status';
import { mapRoot } from '@src/mixins/root';
import { StatusBar } from '@src/components/Statuses';

export default {
  name: 'MinimalLayout',
  components: {
    StatusBar,
  },
  computed: {
    ...mapRoot([ 'company', 'isNativeApp' ]),
    companyID() {
      return this.company ? this.company.id : null;
    },
    companyLogo() {
      return _get(this.company, 'siteBranding.bigLogo.fileLocation', null);
    },
    companyName() {
      return _get(this.company, 'siteBranding.name', _get(this.company, 'name', 'The Referrals Platform'));
    },
    companyURL() {
      const { name } = this.$route;
      return name === 'Logout' ? undefined : '/';
    },
    statuses() {
      return getStatusesForRoute(this.$route).filter(status => status && status.type === 'bar');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/layouts/Minimal.vue